<template>
	<div>
		<CommandsListItem
			v-for="command in commands"
			:key="command.id"
			:command="command"
			@requestDelete="$emit('requestDelete', command)"
			@requestReplay="$emit('requestReplay', command)"
			@requestAnswerPages="$emit('requestAnswerPages', command)"
		/>
	</div>
</template>

<script>
import CommandsListItem from './CommandsListItem'

export default {
	name: 'CommandsList',
	components: {
		CommandsListItem,
	},
	props: {
		commands: {
			type: Array,
			required: true,
		},
	},
	emits: [
		'requestDelete',
		'requestReplay',
		'requestAnswerPages',
	],
};
</script>
